import { IStatsInputPlugin } from "../statsCollectors"
import { Subject, manager } from ".."

const ACTION = manager.ArgumentsEvent.Actions
const EVENTCLASS = manager.ArgumentsEvent.EventClass
export class NetworkInfoPlugin implements IStatsInputPlugin {
  private eventSubject: Subject<manager.Message> = new Subject<manager.Message>()
  public subscribeEvents = () => {
    return this.eventSubject
  }
  public start = (): IStatsInputPlugin => {
    if (window && window["navigator"] && (window["navigator"] as any)["connection"]) {
      const nav: any = window["navigator"]
      const conn: any = nav["connection"]
      this.sendData(conn)
      conn.onchange = () => {
        this.sendData(conn)
      }
    }
    return this
  }
  public stop = () => {
    const nav: any = window["navigator"]
    const conn: any = nav["connection"]
    conn.onchange = null
  }
  private sendData = (conn: any) => {
    this.eventSubject.next(
      new manager.Message({
        Type: manager.MessageType.MessageTypeEvent,
        Timestamp: Date.now(),
        ArgumentsEvent: {
          EventName: EVENTCLASS.NETWORK,
          Action: ACTION.INFO,
          ArgumentsNetworkInfo: {
            NetworkType: `${conn["effectiveType"] || ""}:${conn["type"] || ""}`,
            RTT: parseFloat(conn["rtt"]),
            Downlink: parseFloat(conn["downlink"]),
          },
        },
      }),
    )
  }
}
